/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { AiType, Thread } from '@squiz/dxp-ai-client';
import React from 'react';
import { ViewThreadDialogLauncher } from '../../ViewThread/ViewThreadDialogLauncher/ViewThreadDialogLauncher';

type ThreadNameIdProps = {
  aiType: AiType;
  thread: Thread;
};

export const ThreadNameId = (props: ThreadNameIdProps): JSX.Element => {
  const { thread, aiType } = props;

  return (
    <div className="ai_thread_table_name_id_item">
      <ViewThreadDialogLauncher aiType={aiType} thread={thread} />
      <span className="ai_thread_table_id">#{thread.id}</span>
    </div>
  );
};
